import "../css/Schedule.css"
import { Helmet } from 'react-helmet';

export const Schedule = () => {
  
  return (
    <div style={{"padding":"5%"}} className="Schedule">
            <Helmet>
        <title>当日の流れ|有明海・大牟田市三池港発釣り船 【シーラインⅢ】</title>
        <meta name="description" content="シーラインⅢの当日の流れについてお知らせです。" />
        <meta name="keywords" content="シーラインⅢ, 当日の流れ" />
        <meta property="og:url" content="https://sealine3-new.web.app/Schedule" />
        <link rel="canonical" href="https://sealine3-new.web.app/Schedule" />
      </Helmet>
    <h1>ご案内</h1>
    <h3>当日の流れ</h3>
    <span className="Schedule-container">
    <div>
      <figure>1</figure>
      <p>出航30分前に乗り場に到着</p>
    </div>
    <div>
      <img alt="矢印" src="./images/arrow.webp"/>
    </div>
    <div>
      <figure>2</figure>
      <p>抽選にて釣り席確保</p>
    </div>
    <div>
      <img alt="矢印" src="./images/arrow.webp"/>
    </div>
    <div>
      <figure>3</figure>
      <p>乗船名簿記入</p>
    </div>
    <div>
      <img alt="矢印" src="./images/arrow.webp"/>
    </div>
    <div>
      <figure>4</figure>
      <p>出港</p>
    </div>
    <div>
      <img alt="矢印" src="./images/arrow.webp"/>
    </div>
    <div>
      <figure>5</figure>
      <p>帰港後に会計</p>
    </div>
    </span>
    <br/>
    <h3>ご家族向け</h3>
    <h4>☆小さなお子様☆</h4>
    <p >キス釣りなどがオススメです☆初めてのお子様でも、釣る楽しさを味わえます。<br/>
    竿のレンタルもありますので、ご安心下さい。
    </p>
    <h4>☆出港時間☆</h4>
    <p>お客様のご都合に合せて、８時～９時の出港もできます。</p>
    <h4>☆昼食☆</h4>
    <p>船内にお持ち込みも可能です。船内のベンチソファーや、休憩室などご利用ください。<br/>
    また、ポイント近くの食事処もご案内できますので、お気軽にお問い合わせください。
    </p>
    </div>
  );
};
